<template>
    <Header />
    <router-view />
    <Footer />
    <Cookies v-if="show_cookies && $store.state.cookies" @close="show_cookies = false" />
</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Cookies from "@/components/Cookies.vue";

export default {
    data() {
        return {
            show_cookies: false,
        }
    },
    components: {
        Header,
        Footer,
        Cookies,
    },

    watch: {
        // '$route' (newRoute, oldRoute) {
        //     if (this.is_init && typeof window.ga === 'function') {
        //         setTimeout(() => {
        //             gtag('event', 'page_view', {
        //                 page_path: location.pathname,
        //             });
        //         }, 1000);
        //     } else {
        //         this.is_init = true;
        //     }
        // },
        '$route.params': {
            handler(params) {
                this.updateClass(params);
            },

            immediate: true,
        },
    },

    methods: {
        updateClass(params) {
            // this.$store.state.show_navi = false;
            let body_class = '';
            if (this.$route.name !== 'home') body_class = 'not-home ';
            if (typeof this.$route.name === 'string') body_class = body_class + 'page-' + this.$route.name;
            if (params.slug) body_class = body_class + ' slug-' + params.slug;
            if (params.category) body_class = body_class + ' category-' + params.category;


            document.body.className = body_class;
            this.$store.state.show_menus = false;


            // if (JSON.stringify(this.$route.query) === '{}')  window.scrollTo(0, 0);
            // console.log(this.$store.state.disabled_scroll)

            if (this.$store.state.disabled_scroll) {
                this.$store.state.disabled_scroll = false;
            } else {
                window.scrollTo(0, 0);
            }


            // setTimeout(() => {
            //     let forms = document.querySelectorAll('.wpcf7');
            //     forms.forEach(e => {
            //         if (!e.classList.contains('inited')) {
            //             console.log(e)
            //             let wpcf = new Form(e, window.globals.home_url);
            //             wpcf.init();
            //         }
            //     });
            // }, 1000);

        },

        loadShopify() {
            var script = document.createElement('script');
            script.async = true;
            script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
            // script.onload = ShopifyBuyInit;
        },
    },


    mounted() {
        this.loadShopify();
        if (window.localStorage.getItem('hide_cookies_new') === null) this.show_cookies = true;
        this.$store.state.site_name = window.globals.name;
        this.$store.state.site_description = window.globals.description;
    },
}
</script>

<style lang="scss">
    @import "@/assets/sass/fonts";
    @import "@/assets/sass/reset";

    /********* Base */
    $padding: 1.5rem;

    :root {
        --inner-width: 140rem;
        --base-size: 2.2rem;
        --medium-size: 2.4rem;
        --small-size: 1.4rem;
        --tiny-size: 1.2rem;
        --title-size: 3.6rem;
        --letter-spacing: 0rem;
        // --big-size: 3rem;
        // --large-size: 4rem;
        
        --side-padding: 6.2rem;
        --padding-25: #{$padding / 4};
        --padding-50: #{$padding / 2};
        --padding: #{$padding};
        --padding-x2: #{$padding * 2};
        --padding-x3: #{$padding * 3};
        --padding-x4: #{$padding * 4};

        --padding-50-neg: -#{$padding / 2};
        --padding-neg: -#{$padding};

        // --padding-x5: #{$padding * 5};
        // --padding-x6: #{$padding * 6};
        
        --font: 'Helvetica', Arial, sans-serif;
        --font-color: #000000;
        --bg-color: #e5e5e5;
        --gray: #a9a9a9;
        --yellow: #D4B872;
        // --purple: #C06BE8;
    }

    // @media only screen and (max-width: 800px) {
    //     $padding: 2rem;
    // }

    input,
    text,
    keygen,
    select,
    button,
    meter,
    progress,
    pre {
        font-family: var(--font);
    }

    /********* Links */
    // :focus {
    //     outline: 3px dashed var(--dark-gray);
    // }
    
    a, a:visited, a:active {
        color: var(--font-color);
        // outline: none;
        text-decoration: none;
        // transition: color .2s;
    }

    *[tabindex="0"],
    a:focus {
        // outline-width: 3px;
        // outline-style: dashed;
        outline-color: black;
    }

    a:hover {
        text-decoration: none;
        color: var(--yellow);
    }

    // input:-webkit-autofill {
    //     box-shadow: 0 0 0px 1000px white inset;
    // }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    strong,
    b {
        font-weight: bold;
    }

    i,
    em {
        font-style: italic;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="date"]::-webkit-calendar-picker-indicator {
        background: transparent;
        bottom: 0;
        color: transparent;
        cursor: pointer;
        height: auto;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: auto;
    }

    ::-webkit-input-placeholder {
        color: var(--gray);
    }

    ::-moz-placeholder {
        color: var(--gray);
    }

    :-ms-input-placeholder {
        color: var(--gray);
    }

    :-moz-placeholder {
        color: var(--gray);
    }
    ::-moz-selection {
        background: var(--gray);
        text-shadow: none;
        color: white;
    }

    ::selection {
        background: var(--gray);
        text-shadow: none;
        color: white;
    }

    .mobile-item {
        display: none;
    }

    .desktop-item {
        display: block;
    }

    html {
        -webkit-overflow-scrolling: touch;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        font-size: 10px;
        background-color: #fff;
        overflow-y: overlay;

        &.hide-bar {
            overflow: hidden;
        }
    }

    html body {
        font-family: var(--font);
        color: var(--font-color);
        // font-feature-settings: 'ss02';
        
        /* Font smoothing */
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-size: var(--base-size);
        min-height: 100vh;
        line-height: 1.35;
        // background-color: var(--bg-color);
    }

    i, em {
        font-style: normal;
    }

    .ui-button {
        padding: .7rem 2rem;
        border: .3rem solid;
        font-weight: bold;
        background: var(--yellow);
        border-color: var(--yellow);
        color: var(--font-color);

        &:hover {
            background: var(--font-color);
            border-color: var(--font-color);
            color: white;
        }
    }

    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .3s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    #app,
    .wrap {
        min-height: 100vh;
        display: grid; 
        grid-template-rows: auto 1fr auto;
        grid-template-columns: 100%;
    }

    .inner {
        width: auto;
        max-width: var(--inner-width);
        margin-left: auto;
        margin-right: auto;
        padding-left: var(--side-padding);
        padding-right: var(--padding);
    }

    .cols {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        margin-left: var(--padding-neg);
        margin-right: var(--padding-neg);
    }

    .col-3-2 {
        width: 66.66%;
        box-sizing: border-box;
        padding-left: var(--padding);
        padding-right: var(--padding);
        // margin-left: var(--padding-50-neg);
        // margin-right: var(--padding-50-neg);
    }

    .col-3-1 {
        width: 33.33%;
        box-sizing: border-box;
        padding-left: var(--padding);
        padding-right: var(--padding);
    }

    .col-4-1 {
        width: 25%;
        box-sizing: border-box;
        padding-left: var(--padding);
        padding-right: var(--padding);
    }

    .col-5-1 {
        width: 20%;
        box-sizing: border-box;
        padding-left: var(--padding);
        padding-right: var(--padding);
    }

    .img-wrap {
        position: relative;
        width: 100%;

        &::before {
            display: block;
            content: '';
        }

        img {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            object-fit: cover;
        }

        &.img-3x4 {
            &::before {
                padding-bottom: 75%;
            }
        }

        &.img-4x3 {
            &::before {
                padding-bottom: 150%;
            }
        }

        &.img-1x1 {
            &::before {
                padding-bottom: 100%;
            }
        }
    }

    @media only screen and (max-width: 1500px) {
        html {
            font-size: .6668vw;
        }
    }

    @media only screen and (max-width: 780px) {
        $padding: 2.5rem;

        :root {
            --inner-width: auto;
            --base-size: 3.2rem;
            --medium-size: 3.4rem;
            --small-size: 2.4rem;
            --tiny-size: 2rem;
            --title-size: 4.2rem;
            --letter-spacing: 0rem;
            // --big-size: 3rem;
            // --large-size: 4rem;
            
            --side-padding: #{$padding};
            --padding-25: #{$padding / 4};
            --padding-50: #{$padding / 2};
            --padding: #{$padding};
            --padding-x2: #{$padding * 2};
            --padding-x3: #{$padding * 3};
            --padding-x4: #{$padding * 4};

            --padding-50-neg: -#{$padding / 2};
            --padding-neg: -#{$padding};
        }

        html {
            font-size: 1.5vw;
            overflow: scroll;
        }

        .col-3-2 {
            width: 100%;
        }

        .col-3-1 {
            width: 100%;
        }

        .col-4-1 {
            width: 50%;
        }

        .col-5-1 {
            width: 50%;
        }

    }
</style>
